import { actions } from './supplier/actions';
import { getters } from './supplier/getters';
import { state } from './supplier/state';
import { mutations } from './supplier/mutations';

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};